import PaymentMethods from "./PaymentMethods";
import BillingContact from "./BillingContact";
import BillingAddress from "./BillingAddress";

const paymentFormComponents = {
  PaymentMethods,
  BillingContact,
  BillingAddress
}

export default paymentFormComponents